/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import { useAtomValue } from "jotai";
import { Swiper, SwiperSlide } from "swiper/react";
import { appData, bookmarkStore } from "@stores/bookdata";
import BookItemCover from "./BookItemCover";

const Wrap = styled.div`
  position: relative;
  margin-bottom: 80px;
`;

const LabelBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 358px;
  height: 358px;
  font-size: 70px;
  color: #fff;
  border-radius: 50%;
  background-size: 500px;
  background-color: #3aace2;
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 20px,
    #49b5e8 20px,
    #49b5e8 40px
  );
  animation: seekBarAni 5s linear infinite;
  > span {
    text-shadow: 5px 4px 0px rgba(0, 0, 0, 20%);
  }
`;

// const Title = styled.div`
//   color: #fff;
//   font-size: 70px;
// `;
// const Desc = styled.span`
//   position: absolute;
//   bottom: 25px;
//   font-size: 22px;
//   color: #fff;
//   opacity: 0.75;
// `;
// const Grade = styled.strong`
//   position: absolute;
//   right: 20px;
//   top: 20px;
//   padding: 5px 25px;
//   background-color: #fff;
//   border-radius: 25px;
//   font-size: 30px;
//   color: ${(props) => props.color};
// `;

const BookContainer = styled.div`
  position: absolute;
  top: 0;
  left: 360px;
  width: 1330px;
`;

const BookMarkBox = () => {
  const curBookMark = useAtomValue(bookmarkStore);
  const data = useAtomValue(appData);
  const swiperRef = useRef();

  const renderList = useCallback(() => {
    return curBookMark
      .map((bookmark) => {
        return data.studybooks
          .flatMap((d) => d.books)
          .filter((a) => a.key === bookmark)[0];
        //bookmark
      })
      .map((fd, i) => {
        return (
          <SwiperSlide width={360} key={i}>
            <BookItemCover bookData={fd} isBookmark={true} />
          </SwiperSlide>
        );
      });
  }, [curBookMark]);

  useEffect(() => {
    if (swiperRef && swiperRef.current && swiperRef.current.swiper) {
      if (curBookMark.length > 3) {
        swiperRef.current.swiper.enabled = true;
      } else {
        swiperRef.current.swiper.slideTo(0);
        swiperRef.current.swiper.enabled = false;
      }
    }
  }, [curBookMark]);
  return curBookMark.length > 0 ? (
    <Wrap id="bookmarkBox">
      <LabelBox>
        <span>
          즐겨
          <br />
          찾기
        </span>
      </LabelBox>
      <BookContainer>
        <Swiper
          spaceBetween={15}
          slidesPerView={3.45}
          slidesOffsetAfter={30}
          slidesOffsetBefore={30}
          ref={swiperRef}
        >
          {renderList()}
        </Swiper>
      </BookContainer>
    </Wrap>
  ) : null;
};
export default React.memo(BookMarkBox);
